import { render, staticRenderFns } from "./operateRisks.vue?vue&type=template&id=d1f4deca&scoped=true&"
import script from "./operateRisks.vue?vue&type=script&lang=js&"
export * from "./operateRisks.vue?vue&type=script&lang=js&"
import style0 from "./operateRisks.vue?vue&type=style&index=0&id=d1f4deca&prod&scoped=true&lang=css&"
import style1 from "./operateRisks.vue?vue&type=style&index=1&id=d1f4deca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f4deca",
  null
  
)

export default component.exports